import React, { useEffect, useState } from "react"
import Helmet from "react-helmet"
import Seo from "components/seo"
import Layout from "components/layout"
//Utils
import {
  F_Q_PRODUCT,
  F_Q_PAGES,
  F_Q_WISHLIST,
  F_Q_STOCK,
  sendDatalayerProduct,
} from "lib/function"
import Nookies from "nookies"

//Components
import ProductDetailsComp from "@components/pages/product-details"
import { useRouter } from "next/router"

const ProductDetails = ({ slug, ...props }) => {
  const Router = useRouter()
  // For Datalayer ************************************************************
  const [hasSent, setHasSent] = useState(false)

  // Reset hasSent when product id changes
  useEffect(() => {
    setHasSent(false)
  }, [props?.data?.product?.id])

  useEffect(() => {
    if (!hasSent && props?.data?.product?.id) {
      sendDatalayerProduct({
        event: "view_item",
        data: {
          ...props?.data?.product,
          listName: Router.query?.listName || "Product Details",
          index: Router?.query?.index || 1,
        },
        type: 2,
      })
      setHasSent(true)
    }
  }, [
    hasSent,
    props?.data?.product?.id,
    Router.query?.listName,
    Router?.query?.index,
  ])
  // For Datalayer ************************************************************
  return (
    <>
      <Seo title={props.data.product.title} />
      <Helmet>
        <body className="bd-product-details" />
      </Helmet>
      <Layout>
        <ProductDetailsComp {...props} />
      </Layout>
    </>
  )
}

export default ProductDetails

export const getServerSideProps = async (ctx) => {
  let access
  const accessToken = Nookies.get(ctx)[`${process.env.INIT_TOKEN}`]
  if (accessToken) access = accessToken
  else access = `${process.env.INIT_TOKEN}`
  let { slug } = ctx?.query
  let { locale } = ctx
  if (!slug) return { notFound: true }
  let id = slug.split("-")[slug.split("-").length - 1]
  if (!id) return { notFound: true }
  try {
    // let wishlists = await F_Q_WISHLIST({ lang: locale }, token)
    let { data, errors } = await F_Q_PRODUCT({ id, lang: locale }, access)
    let pages = await F_Q_PAGES({ lang: locale }, access)
    if (data && pages?.data) {
      if (!data?.product) return { notFound: true }
      let { product } = data
      let skuId = product?.skus[0].id
      let stockResult = await F_Q_STOCK({ id: skuId }, access)
      let deliveryInfo = pages.data.pages.find((item) => item.id === "3")
      return {
        props: {
          slug,
          data,
          locale,
          deliveryInfo,
          // wishlists: wishlists.data,
          token: access,
          stock: stockResult?.data?.stock,
        },
      }
    } else {
      return { notFound: true }
    }
  } catch (error) {
    return { notFound: true }
  }
}

// export const getServerSideProps = async (ctx) => {
//   let { user_status, token } = await TokenValidation(ctx)
// let { slug } = ctx?.query
// let { locale } = ctx
// if (!slug) return { notFound: true }
// let id = slug.split("-")[slug.split("-").length - 1]
// if (!id) return { notFound: true }
//   // Asycn functions
// try {
//   // let wishlists = await F_Q_WISHLIST({ lang: locale }, token)
//   let { data, errors } = await F_Q_PRODUCT({ id, lang: locale }, token)
//   let pages = await F_Q_PAGES({ lang: locale }, token)
//   if (data && pages?.data) {
//     if (!data?.product) return { notFound: true }
//     let { product } = data
//     let skuId = product?.skus[0].id
//     let stockResult = await F_Q_STOCK({ id: skuId }, token)
//     let deliveryInfo = pages.data.pages.find((item) => item.id === "3")
//     return {
//       props: {
//         data,
//         locale,
//         deliveryInfo,
//         // wishlists: wishlists.data,
//         token,
//         stock: stockResult?.data?.stock,
//       },
//     }
//   } else {
//     return { notFound: true }
//   }
// } catch (error) {
//   return { notFound: true }
// }
// }
